import { useQuery } from '@tanstack/react-query';
import { makeWordsUsageQueryKeyPrefix } from 'features/wordsUsage/invalidateWordsUsageQueries';
import CustomerAPI from 'services/api/customer';

export function useGetWordsUsageHistory() {
  return useQuery([...makeWordsUsageQueryKeyPrefix(), 'history'], () => {
    return CustomerAPI.getWordsUsageHistory();
  });
}
